var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_403"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_403",
    "data-name": 403,
    className: "cls-2",
    d: "M68.52,5.52C77,11.07,78.84,21.76,80.71,41.88c2.74,29.45,4,44.27,0,48.58-12,12.82-45.37,8.37-57.74-9.06C4.3,55.07,36.17,2.73,57.86,2.17A19.78,19.78,0,0,1,68.52,5.52Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat403);
export default __webpack_public_path__ + "static/media/cat_403.00caac2935df41edca5ad349dac4b7be.svg";
export { ForwardRef as ReactComponent };